var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useRef, useState } from 'react';
import { useAuthStrategy } from '../../../authentication';
export var ASSISTANT_CHAT_API = '/api/dashboards/assistant/chat';
/** What the api rereads of the conversation, and the most it accepts of one message. */
var MAX_HISTORY = 20;
var MAX_MESSAGE_LENGTH = 8000;
/** Calls `onEvent` for each line of a newline-delimited JSON stream, until it ends. */
export function readEvents(body, onEvent) {
  return __awaiter(this, void 0, void 0, function () {
    var reader, decoder, buffer, flush, _a, value, done, newline;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          reader = body.getReader();
          decoder = new TextDecoder();
          buffer = '';
          flush = function (text) {
            var line = text.trim();
            if (line) {
              onEvent(JSON.parse(line));
            }
          };
          _b.label = 1;
        case 1:
          return [4 /*yield*/, reader.read()];
        case 2:
          _a = _b.sent(), value = _a.value, done = _a.done;
          if (done) {
            return [3 /*break*/, 4];
          }
          buffer += decoder.decode(value, {
            stream: true
          });
          newline = buffer.indexOf('\n');
          while (newline >= 0) {
            flush(buffer.slice(0, newline));
            buffer = buffer.slice(newline + 1);
            newline = buffer.indexOf('\n');
          }
          _b.label = 3;
        case 3:
          return [3 /*break*/, 1];
        case 4:
          flush(buffer + decoder.decode());
          return [2 /*return*/];
      }
    });
  });
}
var lastEntryId = 0;
var nextEntryId = function () {
  lastEntryId += 1;
  return lastEntryId;
};
/** The conversation with the dashboards assistant, held for as long as the page is open. */
export var useAssistantChat = function (_a) {
  var view = _a.view,
    path = _a.path;
  var authStrategy = useAuthStrategy();
  var _b = useState([]),
    entries = _b[0],
    setEntries = _b[1];
  var _c = useState(false),
    pending = _c[0],
    setPending = _c[1];
  /** The tool the assistant is running, while it works. */
  var _d = useState(),
    step = _d[0],
    setStep = _d[1];
  var abortRef = useRef();
  useEffect(function () {
    return function () {
      var _a;
      return (_a = abortRef.current) === null || _a === void 0 ? void 0 : _a.abort();
    };
  }, []);
  var send = useCallback(function (question) {
    return __awaiter(void 0, void 0, void 0, function () {
      var asked, conversation, abort, links, reply, _a, headers, withCredentials, authHeaders, res, _b, answered;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            asked = {
              id: nextEntryId(),
              role: 'user',
              content: question
            };
            conversation = __spreadArray(__spreadArray([], entries.filter(function (entry) {
              return !entry.error;
            }), true), [asked], false).slice(-MAX_HISTORY).map(function (_a) {
              var role = _a.role,
                content = _a.content;
              return {
                role: role,
                content: content.slice(0, MAX_MESSAGE_LENGTH)
              };
            });
            setEntries(function (previous) {
              return __spreadArray(__spreadArray([], previous, true), [asked], false);
            });
            setPending(true);
            setStep(undefined);
            abort = new AbortController();
            abortRef.current = abort;
            links = [];
            reply = {
              role: 'assistant',
              content: '',
              error: 'failed'
            };
            _c.label = 1;
          case 1:
            _c.trys.push([1, 5,, 6]);
            _a = authStrategy.getRequestOptions(), headers = _a.headers, withCredentials = _a.withCredentials;
            authHeaders = Object.fromEntries(Object.entries(headers !== null && headers !== void 0 ? headers : {}).filter(function (header) {
              return typeof header[1] === 'string';
            }));
            return [4 /*yield*/, fetch(ASSISTANT_CHAT_API, {
              method: 'POST',
              credentials: withCredentials ? 'include' : 'same-origin',
              headers: __assign(__assign({}, authHeaders), {
                'Content-Type': 'application/json'
              }),
              body: JSON.stringify({
                messages: conversation,
                view: view,
                path: path
              }),
              signal: abort.signal
            })];
          case 2:
            res = _c.sent();
            if (res.status === 401) {
              authStrategy.onUnauthorized();
            }
            if (!(res.ok && res.body)) return [3 /*break*/, 4];
            return [4 /*yield*/, readEvents(res.body, function (event) {
              if (event.type === 'step') {
                setStep(event.tool);
              } else if (event.type === 'link') {
                links.push({
                  kind: event.kind,
                  title: event.title,
                  path: event.path
                });
              } else if (event.type === 'answer') {
                reply = {
                  role: 'assistant',
                  content: event.content
                };
              } else {
                reply = {
                  role: 'assistant',
                  content: '',
                  error: event.code
                };
              }
            })];
          case 3:
            _c.sent();
            _c.label = 4;
          case 4:
            return [3 /*break*/, 6];
          case 5:
            _b = _c.sent();
            if (abort.signal.aborted) {
              return [2 /*return*/];
            }
            return [3 /*break*/, 6];
          case 6:
            answered = __assign(__assign(__assign({}, reply), {
              id: nextEntryId()
            }), links.length > 0 && {
              links: links
            });
            setEntries(function (previous) {
              return __spreadArray(__spreadArray([], previous, true), [answered], false);
            });
            setPending(false);
            setStep(undefined);
            return [2 /*return*/];
        }
      });
    });
  }, [entries, view, path, authStrategy]);
  var reset = useCallback(function () {
    var _a;
    (_a = abortRef.current) === null || _a === void 0 ? void 0 : _a.abort();
    setEntries([]);
    setPending(false);
    setStep(undefined);
  }, []);
  return {
    entries: entries,
    pending: pending,
    step: step,
    send: send,
    reset: reset
  };
};